import React from 'react';
import { Tag } from 'antd';
import {
  APP_BUILD_REVIEW_STATUS,
  REVIEW_STATUS_COLORS,
} from '../../../common/constants';

function StatusBadge({ status }) {
  const normalizedStatus = status?.replace(/\s+/g, '_');
  const color = REVIEW_STATUS_COLORS[normalizedStatus] || 'default';
  const label =
    APP_BUILD_REVIEW_STATUS.find((s) => s.value === normalizedStatus)?.label ||
    status ||
    '-';
  return <Tag color={color}>{label}</Tag>;
}

export default StatusBadge;
